// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1q0if","header":"styles_header__H4Wu6","title":"styles_title__WjY4w","tableHeader":"styles_tableHeader__1STwH"};